function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.3791 1.52231L20.8493 14.8381C21.0137 15.2356 21.0857 15.5588 21.1062 15.8945C21.1473 16.6789 20.8802 17.4414 20.3561 18.0282C19.8321 18.6129 19.1231 18.958 18.3524 18.9999H3.30929C2.99075 18.98 2.67222 18.9057 2.37423 18.7907C0.884302 18.1736 0.165026 16.4373 0.771273 14.9322L8.29284 1.5129C8.54972 1.04118 8.94019 0.634311 9.42313 0.372828C10.8206 -0.423129 12.5982 0.0998385 13.3791 1.52231ZM11.7248 10.2977C11.7248 10.7997 11.324 11.2192 10.8308 11.2192C10.3376 11.2192 9.92657 10.7997 9.92657 10.2977V7.33873C9.92657 6.83564 10.3376 6.42877 10.8308 6.42877C11.324 6.42877 11.7248 6.83564 11.7248 7.33873V10.2977ZM10.8308 14.7964C10.3376 14.7964 9.92657 14.3769 9.92657 13.8759C9.92657 13.3728 10.3376 12.9545 10.8308 12.9545C11.324 12.9545 11.7248 13.3634 11.7248 13.8644C11.7248 14.3769 11.324 14.7964 10.8308 14.7964Z",
  fill: "#FFB800"
});

function SvgWarningSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningSmall);
export default __webpack_public_path__ + "static/media/warning-small.651151ed.svg";
export { ForwardRef as ReactComponent };